export const CODE_SUCCESS = 'api.success';
export const CODE_UNAUTHORIZED = 'api.unauthorized';
// 如果修改 cc-provider 项目也需要同步
export const SESSION_KEY = 'ccodv3';
